// extracted by mini-css-extract-plugin
export default {"root":"RiskNotice_root__bSSlW","submit":"RiskNotice_submit__vgk1G","submitWrapper":"RiskNotice_submitWrapper__axgfA"};